import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { styled } from '@egoist/vue-emotion'
import * as getters from '../../../../builder/src/js/store/modules/getters'
import * as actions from '../../../../builder/src/js/store/modules/actions'
import * as constants from '../../../../builder/src/js/common/constants/constants'
import { mapGetters, mapState, mapActions } from 'vuex'
import CvtButton from '../../molecules/Button'
import CvtInput from '../../molecules/Input'
import CvtSelect from '../../molecules/Select'
import CvtCustomCheckbox from '../../molecules/CustomCheckbox'
import CvtRadioGroup from '../../molecules/radio-group/RadioGroup'
import { IntegrationReady } from './integration-ready'
import { IntegrationDescription } from './integration-description'
Vue.use(VueI18n)

let textFontWeight, textFontSize, Spacing, FontSize, backgroundColor, Colors

const getAuthenticationDescription = () => styled('div')`
  background: ${Colors.BASIC[100]};
`

const getHorizontalLine = () => styled('div')`
  border-top: 1px solid ${Colors.BASIC[300]};
  margin-bottom: 15px;
`

const getAuthSuccessBtnWrap = () => styled('div')`
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
`

const getInput = () => styled(CvtInput)`
  margin-bottom: 23px;
  > div {
    border-radius: 4px;
    border: 2px solid ${Colors.BASIC[300]};
  }
  > div > div {
    border-radius: 0;
    border: 0;
  }
`

const getSelect = () => styled(CvtSelect)`
  width: 100%;
  margin-bottom: 23px;

  > div {
    border-radius: 4px;
  }

  div > div {
    border-radius: 0;
    border: 0;
  }
`

const getSelectPipelineText = () => styled('p')`
  margin-bottom: 6px;
`

const getFieldsCaption = () => styled('p')`
  font-size: 14px;
`

const getMatchFieldsText = () => styled('p')`
  font-size: 14px;
`

const getAuthDescriptionHeader = () => styled('p')`
  font-weight: 700;
  font-size: 14px;
  color: ${Colors.BASIC[500]};
`

const getCustomCheckbox = () => styled(CvtCustomCheckbox)``

export const HubspotIntegration = {
  name: 'HubspotIntegration',
  components: {
    CvtRadioGroup,
  },
  data() {
    return {
      hubspotFields: [1, 2, 3],
      showPipelineSelect: false,
    }
  },
  props: {
    mode: {
      type: String,
      default: 'LIGHT',
    },
  },
  computed: {
    ...mapGetters({
      config: getters.AUTH_GET_USER_CONFIG,
      selectedIntegration: getters.SELECTED_INTEGRATION,
      currentStep: getters.GET_INTEGRATIONS_AUTH_STEP,
      formFieldGroups: getters.FORM_EDITOR_FIELD_GROUPS,
    }),
    ...mapGetters('globalTheme', {
      textFontSize: getters.GLOBAL_STYLE_FONT_SIZE,
      textFontWeight: getters.GLOBAL_STYLE_FONT_WEIGHT,
      backgroundColor: getters.GLOBAL_STYLE_BACKGROUND_COLOR,
    }),
    ...mapState('globalTheme', {
      Colors: ({ globalTheme }) => globalTheme.Colors,
      FontSize: ({ globalTheme }) => globalTheme.FontSize,
      Spacing: ({ globalTheme }) => globalTheme.Spacing,
      globalTheme: ({ globalTheme }) => globalTheme,
    }),

    getHubspotDefaultOptions() {
      return ['Option 1', 'Option 2', 'Option 3']
    },

    getConvrrtFormFields() {
      return this.formFieldGroups[0].fields || []
    },
  },
  created() {
    textFontSize = this.textFontSize
    textFontWeight = this.textFontWeight
    Spacing = this.Spacing
    FontSize = this.FontSize
    backgroundColor = this.backgroundColor
    Colors = this.Colors
  },
  mounted() {
    this.onScrollInToView()
  },
  methods: {
    ...mapActions('globalTheme', {}),
    ...mapActions({
      onChangeStep: actions.UPDATE_INTEGRATIONS_AUTH_STEP,
      onChangeScreen: actions.UPDATE_INTEGRATIONS_CURRENT_SCREEN,
    }),

    onScrollInToView() {
      const container = document.getElementById('authWrap')
      container.scrollIntoView()
    },

    onStepToIntegrationsScreen() {
      this.onChangeScreen(constants.INTEGRATIONS)
    },

    onChangeAuthStep(step: string) {
      this.onChangeStep(step)
      this.onScrollInToView()
    },

    onCheckDeal() {
      this.showPipelineSelect = !this.showPipelineSelect
    },
  },
  render: function (h) {
    const AuthenticationDescription = getAuthenticationDescription()
    const HorizontalLine = getHorizontalLine()
    const AuthSuccessBtnWrap = getAuthSuccessBtnWrap()
    const Input = getInput()
    const Select = getSelect()
    const SelectPipelineText = getSelectPipelineText()
    const FieldsCaption = getFieldsCaption()
    const MatchFieldsText = getMatchFieldsText()
    const AuthDescriptionHeader = getAuthDescriptionHeader()

    const CustomCheckbox = getCustomCheckbox()

    const getHubspotOptions = this.getHubspotDefaultOptions.map(
      (option, index) => {
        return (
          <option id={index} value={option}>
            {option}
          </option>
        )
      },
    )

    return (
      <div style="width: 100%;">
        {this.currentStep === constants.AUTH_INIT && <IntegrationDescription />}

        {this.currentStep === constants.AUTH_SUCCESS && (
          <div>
            <AuthenticationDescription>
              <div style="padding: 45px;">
                <div>
                  <AuthDescriptionHeader>
                    Create a new contact or Update an existing one
                  </AuthDescriptionHeader>
                  <MatchFieldsText>Match your fields</MatchFieldsText>
                  <HorizontalLine></HorizontalLine>

                  <div style="display: flex;gap: 30px;">
                    <div style="flex:1;">
                      <FieldsCaption>Your Convrrt Form Field</FieldsCaption>

                      <div>
                        {this.getConvrrtFormFields.map((field) => (
                          <Input
                            label=""
                            size="small"
                            mode={this.mode}
                            color="black"
                            placeholder={field.label}
                            value={''}
                            onClear={() => {}}
                            onInput={(e) => {}}
                          ></Input>
                        ))}
                      </div>
                    </div>

                    <div style="flex:1;">
                      <FieldsCaption>Desired HubSpot Field</FieldsCaption>

                      <div>
                        {this.hubspotFields.map(() => (
                          <Select placeholder="Client Name">
                            {getHubspotOptions}
                          </Select>
                        ))}
                      </div>
                    </div>
                  </div>

                  <CustomCheckbox
                    style="margin-bottom: 18px;"
                    fontSize="14px"
                    label="Update if contact already exists"
                    checked={false}
                  />

                  <HorizontalLine></HorizontalLine>

                  <CustomCheckbox
                    style="margin-bottom: 15px;"
                    fontSize="14px"
                    label="Create a Deal"
                    checked={false}
                    onChange={(event) => this.onCheckDeal()}
                  />

                  {this.showPipelineSelect && (
                    <div>
                      <SelectPipelineText>Select a pipeline</SelectPipelineText>
                      <Select placeholder="Client Name">
                        <option id="pipleline 1" value="pipleline 1">
                          pipleline 1
                        </option>
                        <option id="pipleline 2" value="pipleline 2">
                          pipleline 2
                        </option>
                      </Select>
                    </div>
                  )}
                </div>
              </div>
            </AuthenticationDescription>

            <AuthSuccessBtnWrap>
              <CvtButton
                text="Cancel"
                outlined={true}
                specialPadding="12px"
                color="light"
                onClick={() => {}}
              ></CvtButton>
              <CvtButton
                text="Save"
                outlined={true}
                specialPadding="12px"
                disabled={false}
                color="success"
                onClick={() =>
                  this.onChangeAuthStep(constants.INTEGRATION_COMPLETE)
                }
              ></CvtButton>
            </AuthSuccessBtnWrap>
          </div>
        )}

        {this.currentStep === constants.INTEGRATION_COMPLETE && (
          <IntegrationReady />
        )}
      </div>
    )
  },
}
